var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Icon, AccordionHeader, AccordionPanel, StyledAccordionTitle, AccordionHeaderInfo, AccordionHeaderControl, } from './styles';
import { faCaretDown, faCaretRight } from '@fortawesome/pro-solid-svg-icons';
export var ModernAccordion = function (_a) {
    var title = _a.title, icon = _a.icon, controlIcons = _a.controlIcons, children = _a.children;
    var _b = useState(false), isCollapsed = _b[0], setCollapsed = _b[1];
    var toggleAccordionState = function () {
        setCollapsed(!isCollapsed);
    };
    return (_jsxs("div", { children: [_jsxs(AccordionHeader, { children: [_jsxs(AccordionHeaderInfo, { children: [_jsx(Icon, { iconSize: 16, icon: isCollapsed ? faCaretRight : faCaretDown, onClick: toggleAccordionState }), icon && _jsx(Icon, { iconSize: 12, icon: icon }), _jsx(StyledAccordionTitle, { children: title })] }), _jsx(AccordionHeaderControl, { children: (controlIcons === null || controlIcons === void 0 ? void 0 : controlIcons.length) ? (controlIcons === null || controlIcons === void 0 ? void 0 : controlIcons.map(function (controller, index) { return (_jsx(Icon, { iconSize: 16, icon: controller.icon, onClick: controller.onClick }, index.toString())); })) : (_jsx(_Fragment, {})) })] }), _jsx(AccordionPanel, __assign({ hidden: isCollapsed }, { children: children }))] }));
};
